import React, { useState } from 'react';
import { Modal, Upload, Alert, List, Button, Typography } from 'antd';
import { PlusOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { postFile } from '../../../../utils/fetch';
import { URL_FILES_OP } from '../../../../constants/url';

const { Text } = Typography;

export default function ModalCargaMasivaPDFs({ visible, onClose, onSuccess }) {
  const [listaDocumentos, setListaDocumentos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const _URL_DEV = `${URL_FILES_OP}/CargaPago`;

  const beforeUpload = (file, fileList) => {
    setUploading(true);
    return true;
  };

  const handleChange = ({ file, fileList }) => {
    const completed = fileList.filter(
      (f) => f.status === "done" || f.status === "error"
    ).length;
    if (completed === fileList.length && fileList.length > 0) {
      setUploading(false);
    }
  };

  const handleClose = () => {
    setListaDocumentos([]);
    setLoading(false);
    setUploading(false);
    onClose();
  };

  const handleFinish = () => {
    if (onSuccess) {
      onSuccess();
    }
    handleClose();
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Cargar Documentos</div>
    </div>
  );

  return (
    <Modal
      title="Carga Masiva de Comprobantes de Pago"
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button key="close" onClick={handleClose}>
          Cerrar
        </Button>,
        listaDocumentos.length > 0 && (
          <Button key="finish" type="primary" onClick={handleFinish}>
            Finalizar
          </Button>
        )
      ]}
      width={600}
      className="pagos-v2-modal"
      wrapClassName="pagos-v2-modal"
    >
      <Alert
        style={{ marginBottom: 20 }}
        type="info"
        message="Se pueden cargar multiples documentos, ejemplo de documento: 2541254.pdf"
      />

      <Upload.Dragger
        customRequest={async ({ file, onSuccess: onUploadSuccess, onError }) => {
          try {
            const formData = new FormData();
            formData.append("file", file);
            const response = await postFile(_URL_DEV, formData);

            if (response.code !== 0) {
              setListaDocumentos((prev) => [
                ...prev,
                { name: file.name, msg: response.error, ok: false },
              ]);
              onError("Error al cargar el archivo");
            } else {
              setListaDocumentos((prev) => [
                ...prev,
                { name: file.name, msg: "ok", ok: true },
              ]);
              onUploadSuccess("Archivo subido con éxito");
            }
          } catch (err) {
            setListaDocumentos((prev) => [
              ...prev,
              { name: file.name, msg: err.message, ok: false },
            ]);
            onError(err);
          }
        }}
        onChange={handleChange}
        multiple={true}
        showUploadList={false}
        beforeUpload={beforeUpload}
        disabled={loading}
        style={{ width: '100%' }}
      >
        {uploadButton}
      </Upload.Dragger>

      {listaDocumentos.length > 0 && (
        <div style={{ marginTop: 20 }}>
          <Text strong>Resultados de carga:</Text>
          <List
            size="small"
            bordered
            dataSource={listaDocumentos}
            renderItem={(item) => (
              <List.Item>
                {item.ok ? (
                  <CheckCircleOutlined style={{ marginRight: 8 }} />
                ) : (
                  <CloseCircleOutlined style={{ marginRight: 8 }} />
                )}
                <Text style={{ flex: 1 }}>{item.name}</Text>
                {!item.ok && <Text type="danger">{item.msg}</Text>}
              </List.Item>
            )}
          />
        </div>
      )}
    </Modal>
  );
}